import { defineStore } from "pinia";
import { ref } from "vue";

export const useNstmDetailsStore = defineStore("nstmFatigueDetails", () => {
  const nstmFatigueValue = ref({});

  const setNstmFatigueValue = (value) => {
    nstmFatigueValue.value = value;
  };
  return { nstmFatigueValue, setNstmFatigueValue };
});
